module.exports = __webpack_public_path__ + "img/d24.9d0092a9.png";